// import { React } from "globalthis/implementation";
import React, { useEffect } from 'react';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';

const Notification = props => {
    const { notification } = useSelector(state => state);

    useEffect(() => {
        if (notification.type === 'error') {
            NotificationManager.error(notification.message, '', 4000, null, false);
        }
        if (notification.type === 'success') {
            NotificationManager.success(notification.message, '', 4500, null, false);
        }
        if (notification.type === 'warning') {
            NotificationManager.warning(notification.message, '', 3000);
        }
        return () => {};
    }, [notification]);

    return <NotificationContainer />;
};
export default Notification;
